import { DecimalPipe, PercentPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { I18nLocaleFactory } from '../i18n/i18n.module';
import { I18nService } from '../i18n/i18n.service';

@Pipe({
    name: 'cmpsNumber',
})
export class CmpsDecimalPipe implements PipeTransform {
    constructor(private readonly _i18nService: I18nService) {}

    transform(value: any, digits?: string): string | null {
        const locale = I18nLocaleFactory(this._i18nService);
        return new DecimalPipe(locale).transform(value, digits);
    }
}

@Pipe({
    name: 'cmpsPercent',
})
export class CmpsPercentPipe implements PipeTransform {
    constructor(private readonly _i18nService: I18nService) {}

    transform(value: any, digits?: string): string | null {
        const locale = I18nLocaleFactory(this._i18nService);
        return new PercentPipe(locale).transform(value, digits);
    }
}
